import styled from 'styled-components';
import { rtl } from '../../../utils/language';
import Container from '../Container/Container';
import { mediaQueries } from '../MediaQueries/mediaQueries';

export const Title = styled.div`
  font-family: var(--font-family-signika);
  font-size: 18px;
  font-weight: bold;
  line-height: normal;
  margin-bottom: 32px;
  overflow: hidden;
  text-overflow: ellipsis;

  ${rtl`
    font-family: Tajawal;
  `};
`;
export const InfoWrapper = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${rtl`
      text-align: right;
  `};

  div {
    font-family: var(--font-family-signika);
    font-size: 16px;
    font-weight: 300;
    line-height: 20px;
    word-wrap: break-word;
  }
`;
export const Label = styled.div`
  font-family: var(--font-family-signika) !important;
  font-size: 18px !important;
  font-weight: bold !important;
  line-height: normal !important;

  ${rtl`
    font-family: Tajawal !important;
  `};
`;
export const Grade = styled.div`
  ${rtl`
    text-align: left;
  `};
`;
export const ButtonsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  span {
    ${mediaQueries('screen-small', 'min')`
       padding-left: 8px;
       padding-right: 8px;
  `};
  }

  button {
    font-family: var(--font-family-signika);
    font-size: 14px;
    font-weight: bold;
    line-height: 1.5;

    ${mediaQueries('screen-small', 'min')`
      font-size: 16px;
      width: 180px;
  `};
  }

  > div {
    display: flex;
    justify-content: center;
    height: 100px;
    width: 100%;
    align-items: center;
  }
`;
export const FlexContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  gap: 10px;

  ${mediaQueries('screen-medium', 'min')`
      justify-content: flex-end;
  `};
`;
export const UploadedFileDetails = styled.div`
  padding: 15px;
  font-family: var(--font-family-signika) !important;
  font-size: 18px !important;
  font-weight: bold !important;
  line-height: normal !important;

  display: flex;
  flex-direction: ${props => (props.isSubmitted ? 'column' : 'row')};
  justify-content: ${props =>
    props.isSubmitted ? 'flex-start' : 'space-between'};

  ${mediaQueries('screen-medium', 'min')`
      border-radius: 4px;
      border: solid 2px var(--light-gray-border);
      
      justify-content: space-between;
      flex-direction: row;
  `};
`;
export const CommentContainer = styled.div`
  cursor: text;

  textarea {
    min-height: 98px !important;
  }
`;
export const PreviewContainer = styled.div`
  margin-bottom: 20px;
  cursor: text;
  padding: 10px;
  border: ${({ isSubmitted }) =>
    isSubmitted ? 'none' : 'solid 2px var(--light-gray-border)'};
  background-color: ${({ isSubmitted }) => (isSubmitted ? '#f9f9f9' : 'none')};

  border-radius: 6px;
  overflow-wrap: break-word;
`;
export const UploadContainer = styled.div`
  border-radius: 6px;
  border: ${({ hide, isDragOver }) =>
    hide || isDragOver ? 'none' : 'solid 2px #e9e9e9'};
  padding: ${({ hide }) => (hide ? 'none' : '16px')};
  height: fit-content;
`;

export const UploadLabel = styled.div`
  font-family: var(--font-family-signika);
  font-size: var(--font-size-large);
  font-weight: bold;
  letter-spacing: -0.12px;
  margin-bottom: ${({ hide }) => (hide ? '0' : '15px')};

  ${rtl`
      font-family: Tajawal;
    `};
`;
